import { StyleSheet } from 'react-native-unistyles';

// Scoped to Dashboard while the app translation is being refined.
export default StyleSheet.create(({ colors, spacing, shadows, fonts, typography }, { themeName }) => ({
    card: {
        width: { xs: '100%', lg: '48%' },
        maxHeight: 500,
        borderRadius: 3,
        backgroundColor:colors.surface,
        boxShadow: shadows.none,
        overflow: 'hidden',
        _web: {
            width: '100%',
            minHeight: 0,
        },
    },
    // Keep an automatic basis, but never grow into the card's height ceiling.
    // Only the list viewport shrinks when content exceeds that ceiling.
    content: {
        flexGrow: 0,
        flexShrink: 1,
    },
    scroll: {
        flexGrow: 0,
        flexShrink: 1,
    },
    filterStrip: {
        flexGrow: 0,
        flexShrink: 0,
    },
    header: {
        flexShrink: 0,
        paddingBottom: spacing.md,
        marginBottom: spacing.md,
        borderBottomWidth: 1,
        borderBottomColor: colors.borderSubtle,
        gap: spacing.sm,
    },
    titleRow: {
        flex: 1,
        minWidth: 0,
        gap: spacing.sm,
    },
    title: {
        flexShrink: 1,
        fontFamily: fonts.bold,
        fontSize: typography.body,
        color: colors.text,
        textTransform: 'none',
        letterSpacing: -0.2,
    },
}));
